// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selected .cat-c-table-row {
    background: #d0d0e0;
}

.asset-portfolio-table-row::part(native) .cat-c-table-row {
    background: #d0d0e0;
}

.local-time-cest-format {
    font-weight: 400;
    font-size: 16px;
    color: #3f3f3f;
    line-height: 24px;
    margin-top: 0;
    margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/AssetPortfolio/AssetPortfolio.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,iBAAiB;AACrB","sourcesContent":[".selected .cat-c-table-row {\n    background: #d0d0e0;\n}\n\n.asset-portfolio-table-row::part(native) .cat-c-table-row {\n    background: #d0d0e0;\n}\n\n.local-time-cest-format {\n    font-weight: 400;\n    font-size: 16px;\n    color: #3f3f3f;\n    line-height: 24px;\n    margin-top: 0;\n    margin-left: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
